/**
 * Memoria de lo último que se usó, para el usuario experto.
 *
 * La paleta de comandos es la salida rápida: se abre con Ctrl+K y se escribe. El
 * que la usa treinta veces por día vuelve casi siempre a las mismas cinco
 * pantallas, así que recordar el orden de uso reciente convierte «escribir el
 * nombre» en «apretar Enter». Se guarda en `localStorage` —es preferencia de
 * teclado, no dato de negocio— y por usuario/organización para no mezclar
 * historiales entre logins en la misma máquina.
 */

const MAX = 8;

function clave(scope: string): string {
  return `nucleo:recientes:${scope}`;
}

/** Lee los ids recientes, del más nuevo al más viejo. Nunca tira: si el storage
 *  falla (modo privado, cuota), devuelve vacío y la paleta sigue andando. */
export function leerRecientes(scope: string): string[] {
  try {
    const crudo = window.localStorage.getItem(clave(scope));
    if (crudo === null) return [];
    const datos: unknown = JSON.parse(crudo);
    return Array.isArray(datos) ? datos.filter((x): x is string => typeof x === 'string').slice(0, MAX) : [];
  } catch {
    return [];
  }
}

/** Empuja un id al frente (sin duplicar) y recorta a los últimos `MAX`. */
export function registrarUso(scope: string, id: string): void {
  try {
    const previos = leerRecientes(scope).filter((x) => x !== id);
    const nuevos = [id, ...previos].slice(0, MAX);
    window.localStorage.setItem(clave(scope), JSON.stringify(nuevos));
  } catch {
    // El historial es una comodidad: si no se puede guardar, no pasa nada.
  }
}
